<template>
    <div class="settings-card">
        <div class="settings-card-group d-flex justify-content-between align-items-center flex-wrap gap-5">
            <div>{{$trans('storefront::image_editor.laminate')}}</div>

            <div class="btn-nav-group d-flex flex-grow-1 flex-lg-grow-0" style="max-width: 300px">
                <template v-for="option in store.material.laminatingOptions">
                    <button class="btn flex-grow-1 fs-5" :key="option.id" :class="store.laminate === option.title ? 'btn-secondary' : 'btn-outline-secondary'" type="button" @click="store.laminate=option.title">{{$trans(`storefront::image_editor.${option.title}`)}}</button>
                </template>
            </div>
        </div>

        <div class="settings-card-group d-flex gap-4">
            <div class="d-flex flex-column flex-grow-1 fb-0">
                <label for="width">{{$trans('storefront::image_editor.width')}}</label>
                <c-select :options="store.getWidths" v-model="store.width"></c-select>
            </div>
            <div class="d-flex flex-column flex-grow-1 fb-0">
                <label for="height">{{$trans('storefront::image_editor.height')}}</label>
                <c-select :options="store.getHeights" v-model="store.height"></c-select>
            </div>
            <div class="d-flex flex-column flex-grow-1 fb-0">
                <label for="quantity">{{$trans('storefront::image_editor.quantity')}}</label>
                <c-select :options="store.getAmounts" v-model="store.quantity"></c-select>
            </div>
        </div>

        <div class="settings-card-group border-0">
            <div class="d-flex flex-column">
                <label for="message">{{$trans('storefront::image_editor.message')}}</label>
                <input type="text" name="message" class="form-control" v-model="store.message" :placeholder="$trans('storefront::image_editor.add_a_comment')">
            </div>

            <hr style="width: 95%">

            <div class="d-flex justify-content-between align-items-center">
                <div class="fw-600">{{$trans('storefront::image_editor.total_amount')}}</div>
                <div class="fs-2 fw-600">${{ store.getPrice }}</div>
            </div>
        </div>
    </div>
</template>

<script>
 import {useImageEditorStore} from "./store";

 export default {
     setup() {
         const store = useImageEditorStore();

         return {
             store: store,
         }
     },
     created() {
         this.store.setPriceData(window.FleetCart.priceData);
     }
 }
</script>
